<section>
  <div class="modal-content">
    <div class="modal-header bg-primary">
      <h5 class="m-0 me-2 text-white">Deactivate</h5>
      <button type="button" class="close" (click)="modalService.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">

      <ng-container *ngIf="reason">
        <ng-container *ngTemplateOutlet="deactivateUserTemp"></ng-container>
      </ng-container>
      <ng-container *ngIf="!reason">
        <ng-container *ngTemplateOutlet="deactivateTemp"></ng-container>
      </ng-container>

      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modalService.close()">Cancel
        </button>
        <button [disabled]="NotValid" type="button" class="btn w-sm btn-danger" id="delete-product"
          (click)="deactivateIt()">Deactivate
        </button>
      </div>
    </div>
  </div>
</section>


<ng-template #deactivateTemp>
  <div class="mt-2 text-center">
    <lord-icon src="https://assets4.lottiefiles.com/packages/lf20_pwgo9wha.json" trigger="loop"
      colors="primary:#f7b84b,secondary:#f06548" style="width: 193px; height: auto;">
    </lord-icon>
    <div class="mt-1 pt-2 fs-15 mx-4 mx-sm-5">
      <h4>Are you sure ?</h4>
      <p class="text-muted">Are you sure you want to deactivate this '{{title}}' ?</p>
    </div>
  </div>
</ng-template>

<ng-template #deactivateUserTemp>
  <div class="mt-2 text-center">
    <!-- Info Alert -->
    <div class="alert alert-info alert-top-border alert-dismissible fade show" role="alert">
      <i class="ri-information-line me-3 align-middle fs-16 text-info"></i>
      Please, provide a reason for deactivating '{{title}}'.
    </div>
  </div>

  <form [formGroup]="form">
    <div class="form-group">
      <label class="form-label" [redStar]="form.get('reason')">Reason</label>
      <textarea rows="6" class="form-control" formControlName="reason" placeholder="Enter Reason"
        [formControlValidator]="form.get('reason')"></textarea>
      <arv-validation-messages for="reason"></arv-validation-messages>
    </div>
  </form>

</ng-template>